module.exports = __webpack_public_path__ + "static/media/ic_04_safetyandsecure.df206659.svg";